<template>
  <div class="hero-section">
    <div class="hero-header">
      <img :src="siteInfo.logo" alt="公司简介图标" class="logo" />
      <div class="hero-title-wrap">
        <h1 class="title">{{ siteInfo.company || "" }}简介</h1>
        <span class="subtitle">（一站式法律服务对接平台）</span>
      </div>
    </div>

    <div v-html="companyContentHtml"></div>
    <span class="link-box">
      点击这里可跳转：<a href="https://wenshu.court.gov.cn/" target="_blank" class="court-link">中国裁判文书网</a>
    </span>
  </div>
</template>

<script>
function decodeEscapedHtml(content) {
  const source = String(content || "");

  if (!/&lt;\/?[a-z][\s\S]*&gt;/i.test(source)) {
    return source;
  }

  const textarea = document.createElement("textarea");
  textarea.innerHTML = source;

  return textarea.value.replace(
    /([\w:-]+)\s*=\s*[“”]([^“”]*)[“”]/g,
    '$1="$2"',
  );
}

export default {
  name: "CompanyIntro",
  props: {
    siteInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    companyContentHtml() {
      return decodeEscapedHtml(this.siteInfo.company_content);
    },
  },
};
</script>

<style scoped>
.hero-section {
  width: 1128px;
  margin: 0 auto;
  padding-top: 8px;
}

.hero-header {
  position: relative;
  height: 80px;
  margin-bottom: 30px;
}

.logo {
  position: absolute;
  top: 3px;
  left: 6px;
  width: 52px;
  height: 52px;
  object-fit: contain;
}

.title {
  margin: 0;
  padding-top: 2px;
  text-align: center;
  font-size: 34px;
  line-height: 48px;
  font-weight: 700;
  color: #000000;
  letter-spacing: 1px;
}

.hero-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.subtitle {
  font-size: 20px;
  line-height: 48px;
  color: #000000;
}

.link-box {
  border: 1px solid #333;
  padding: 3px;
  font-size: 22px;
  font-weight: 500;
  font-family: system-ui;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  margin-left: 50px;
}

.court-link {
  color: #00e;
}
</style>